import { IS_BLUEWHALE, MODULES } from "@/constants";
import { IPermissions } from "@/modules/User/user.interface";
import routes from "@/routes";
import { lazy } from "react";
import { Navigate } from "react-router-dom";
import AbmRoutes from "./abm.new.routes";
import AbmBetaRoutes from "./abmBeta.routes";
// RETIRED (2026-10-14): Attribution module retired — not granted, hidden for everyone
// import AttributionRoutes from "./attribution.routes";
import CbmBetaRoutes from "./cbmBeta.routes";
// LEGACY (2026-10-14): old Campaign Stats hidden on every brand; its path redirects below.
// import CampaignStatsRoutes from "./campaignStats.routes";
import CampaignStatsBetaRoutes from "./campaignStatsBeta.routes";
import LeadAppendRoutes from "./leadAppend.routes";
import ReportsSetupRoutes from "./reportsSetup.routes";
const Report = lazy(() => import("@/modules/Report"));

/**
 * Old report paths kept alive as redirects so bookmarks land on the new page.
 * Each one is pushed inside the permission branch of the page it points at, so
 * a user without that permission is never redirected into a route they lack.
 */
const CampaignStatsRedirect = {
  path: routes.REPORTS.STATS.INDEX,
  element: <Navigate replace to={`../${routes.REPORTS.STATS_BETA.INDEX}`} />,
};
const AbmRedirect = {
  path: routes.REPORTS.ABM.INDEX,
  element: <Navigate replace to={`../${routes.REPORTS.ABM_BETA.INDEX}`} />,
};

const ReportRoutes = (permission: IPermissions, isAdmin: boolean) => {
  const children = [];
  if (isAdmin || permission[MODULES.CAMPAIGN_STATS]) {
    // LEGACY (2026-10-14): old Campaign Stats hidden on every brand (Bluewhale
    // included); `campaign-stats` now redirects to `campaign-stats-beta`.
    // children.push(CampaignStatsRoutes);
    children.push(CampaignStatsRedirect);
    children.push(CampaignStatsBetaRoutes);
  }
  if (isAdmin || permission[MODULES.ABM_STATS]) {
    // LEGACY (2026-10-14): old ABM page only on Bluewhale ("ABM (Legacy)");
    // every other brand redirects `abm` to the new ABM (`abm-beta`).
    children.push(IS_BLUEWHALE ? AbmRoutes : AbmRedirect);
    children.push(AbmBetaRoutes);
    children.push(CbmBetaRoutes);
  }
  if (isAdmin || permission[MODULES.REPORTS_SETUP]) {
    children.push(ReportsSetupRoutes);
  }
  // RETIRED (2026-10-14): Attribution module retired — not granted, hidden for everyone
  // if (isAdmin || permission[MODULES.ATTRIBUTION]) {
  //   children.push(AttributionRoutes);
  // }
  //FIXME: replace REPORTS_SETUP permission with Lead Append
  if (isAdmin || permission[MODULES.REPORTS_SETUP]) {
    children.push(LeadAppendRoutes);
  }

  return {
    element: <Report />,
    path: routes.REPORTS.INDEX,
    children: children,
  };
};

export default ReportRoutes;
